(() => {
  if (customElements.get('snd-tabbed-media')) return;

  class SndTabbedMedia extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[data-tab-button]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      this.onClick = (event) => {
        const tab = event.target.closest('[data-tab-button]');
        if (!tab || !this.contains(tab)) return;
        this.activate(Number(tab.dataset.tabIndex), true);
      };

      this.onKeydown = (event) => {
        const currentTab = event.target.closest('[data-tab-button]');
        if (!currentTab || !this.contains(currentTab) || this.tabs.length < 2) return;

        const currentIndex = this.tabs.indexOf(currentTab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.activate(nextIndex, true);
      };

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.activate(0, false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.panels?.forEach((panel) => this.pausePanelVideos(panel));
      this.initialized = false;
    }

    activate(index, moveFocus = false) {
      if (!this.panels?.length) return;
      const safeIndex = Math.max(0, Math.min(index, this.panels.length - 1));

      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === safeIndex;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && moveFocus) {
          tab.focus({ preventScroll: true });
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });

      this.panels.forEach((panel, panelIndex) => {
        const active = panelIndex === safeIndex;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) this.playPanelVideos(panel);
        else this.pausePanelVideos(panel);
      });
    }

    playPanelVideos(panel) {
      if (panel.querySelector('[data-video-autoplay="true"]')) {
        panel.querySelectorAll('video').forEach((video) => video.play().catch(() => {}));
      }
    }

    pausePanelVideos(panel) {
      panel.querySelectorAll('video').forEach((video) => video.pause());
    }

    activateBlock(blockId) {
      const panel = this.panels.find((item) => item.dataset.blockId === blockId);
      if (!panel) return;
      this.activate(Number(panel.dataset.tabIndex), false);
    }
  }

  customElements.define('snd-tabbed-media', SndTabbedMedia);

  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('[data-tab-panel]');
    const section = event.target.closest('snd-tabbed-media');
    if (!panel || !section) return;
    section.activateBlock(panel.dataset.blockId);
  });
})();
